import React, { FC, KeyboardEvent } from 'react';
import { Box, Autocomplete, TextField } from '@mui/material';
import { FilterInputProps } from './types';
import { GooglePlacesAutocomplete } from '../../Components/CustomUIElements/GooglePlacesAutocomplete';

const FilterInput: FC<FilterInputProps> = ({
  options,
  value,
  placeholder,
  onValueChange,
  onAdd,
  filterKey
}) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && value?.trim()) {
      event.preventDefault();
      onAdd(value);
    }
  };

  const handlePlaceSelect = (place: google.maps.places.AutocompletePrediction | null) => {
    if (!place?.description) return;
    onAdd(place.description);
  };

  const textInputSx = { '& .MuiInputBase-input': { fontSize: 14 } };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
      {filterKey === 'locations' ? (
        <GooglePlacesAutocomplete
          value={value}
          placeholder={placeholder}
          onValueChange={onValueChange}
          onKeyDown={handleKeyDown}
          onPlaceSelect={handlePlaceSelect}
          textFieldSx={textInputSx}
        />
      ) : (
        <Autocomplete
          size="small"
          freeSolo
          options={options}
          value={value}
          onChange={(_, newValue) => {
            if (newValue) {
              onAdd(newValue);
            }
          }}
          onInputChange={(_, newInputValue) => {
            onValueChange(newInputValue);
          }}
          onKeyDown={handleKeyDown}
          renderInput={(params) => (
            <TextField {...params} placeholder={placeholder} sx={textInputSx} />
          )}
          sx={{ flex: 1 }}
        />
      )}
    </Box>
  );
};

export default FilterInput;
